import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TaskLogicServiceService {

  constructor(private http: HttpClient) { }

  getAdvanceTaskList(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/taskLogic/logicType/advanceTask`
    return this.http.get(url);
  }

  advanceTaskForFrontEnd(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/taskLogic/logicType/advanceTaskForFrontEnd`
    return this.http.get(url);
  }

  getTaskCodeGroupLogic(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/taskLogic/logicType/taskCodeGroupLogic`
    return this.http.get(url);
  }
}
